export default "__VITE_ASSET__WR54KjLY__"